import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import isEqual from 'lodash/isEqual';
import guid from '../service/guid';
import RankingSubscriber from '../service/RankingSubscriber';
import { buildSocketUrl } from '../service/oms';

export default function withRankingSubscription(WrappedComponent) {
    const rankingSub = class SubscribedRanking extends Component {
        static propTypes = {
            // Props
            columns: PropTypes.array.isRequired,
            expression: PropTypes.string,
            limit: PropTypes.number,
            offset: PropTypes.number,
            ranking: PropTypes.string.isRequired,
            sources: PropTypes.oneOfType([
                PropTypes.array,
                PropTypes.string,
            ]).isRequired,
            // @TODO if possiblem, find a better way to solve this
            reloading: PropTypes.bool.isRequired,

            // Dispatchers
            create: PropTypes.func.isRequired,
            update: PropTypes.func.isRequired,
            dispatch: PropTypes.func.isRequired,
            // @TODO if possiblem, find a better way to solve this
            connectionError: PropTypes.func.isRequired,
        };

        static defaultProps = {
            expression: null,
            limit: 5,
            offset: 0,
        };

        componentDidMount() {
            if (!this.channel) {
                RankingSubscriber.start(
                    this.props.create,
                    this.props.update,
                    buildSocketUrl(),
                    this.props.dispatch,
                );
            }

            const params = {
                columns: this.props.columns,
                expression: this.props.expression,
                limit: this.props.limit,
                offset: this.props.offset,
                ranking: this.props.ranking,
                sources: this.props.sources,
            };

            this.channel = guid();
            RankingSubscriber.subscribe(this.channel, params);
        }

        componentWillUnmount() {
            if (this.channel) {
                RankingSubscriber.unsubscribe(this.channel);
            }
        }

        componentWillReceiveProps(nextProps) {
            const currentParams = {
                columns: this.props.columns,
                expression: this.props.expression,
                limit: this.props.limit,
                offset: this.props.offset,
                ranking: this.props.ranking,
                sources: this.props.sources,
                reloading: this.props.reloading,
            };

            const nextParams = {
                columns: nextProps.columns,
                expression: nextProps.expression,
                limit: nextProps.limit,
                offset: nextProps.offset,
                ranking: nextProps.ranking,
                sources: nextProps.sources,
                reloading: nextProps.reloading,
            };

            if (!isEqual(nextParams, currentParams)) {
                if (!this.channel && nextProps.reloading) {
                    this.channel = guid();
                    RankingSubscriber.subscribe(this.channel, nextParams);
                } else if (this.channel) {
                    RankingSubscriber.unsubscribe(this.channel);
                    RankingSubscriber.subscribe(this.channel, nextParams);
                }
            }
        }

        render() {
            return <WrappedComponent {...this.props} />;
        }
    };

    return connect()(rankingSub);
}



/** WEBPACK FOOTER **
 ** /src/shared/hoc/withRankingSubscription.js
 **/